export default __webpack_public_path__ + "static/media/left-section.8d6f2cc7.png";